import { Link } from '@mui/material';

type Props = {
  text: string;
};

function LinkifiedText({ text }: Props): JSX.Element {
  const parts = text.split(/(https?:\/\/[^\s]+)/);

  if (parts.length === 1) return <>{text}</>;

  return (
    <>
      {parts.map((part, i) =>
        i % 2 === 1 ? (
          <Link key={i} href={part} target="_blank" rel="noopener noreferrer">
            {part}
          </Link>
        ) : (
          part
        )
      )}
    </>
  );
}

export default LinkifiedText;
